import axios, { AxiosResponse } from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';

export type TranslationResponseType = {
	deValue?: string;
	frValue?: string;
	itValue?: string;
};

export const fetchTranslation = (label: string): Promise<AxiosResponse<TranslationResponseType>> => {
	const requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/localization/${label}.json`.replace(
		`/${appConfig.env.language}/`,
		'/'
	);
	return axios.get(requestUrl, { withCredentials: false });
};
